import { Controller } from "@hotwired/stimulus"

// Automatically checks parent category when a child is selected
// Parent can still be unchecked independently
export default class extends Controller {
  static targets = ["parent", "child"]

  childChanged(event) {
    const childCheckbox = event.target
    
    if (childCheckbox.checked) {
      // Find the parent checkbox for this child
      const parentId = childCheckbox.dataset.parentId
      if (parentId) {
        const parentCheckbox = this.element.querySelector(`input[data-category-id="${parentId}"]`)
        if (parentCheckbox && !parentCheckbox.checked) {
          parentCheckbox.checked = true
        }
      }
    }
  }
}
